import React from 'react';
import CustomTooltip from '../../common/CustomTooltip/CustomTooltip';
import styles from './ApplicationField.module.css';

type ApplicationFieldProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'children'> & {
  label: string;
  required?: boolean;
  optional?: boolean;
  error?: string;
  labelTooltip?: string;
  children?: React.ReactNode;
};

export default function ApplicationField({
  label,
  required = false,
  optional = false,
  error,
  labelTooltip,
  children,
  id,
  className = '',
  ...inputProps
}: ApplicationFieldProps) {
  const labelElement = (
    <label htmlFor={id} className={styles.label}>
      {label}
      {required && <span className={styles.required}>*</span>}
      {optional && <span className={styles.optional}>(optional)</span>}
    </label>
  );

  return (
    <div className={styles.field}>
      {labelTooltip ? (
        <CustomTooltip
          title={labelTooltip}
          position="top-start"
          withArrow={false}
          color="#303030"
          radius="8px"
          events={{ hover: true, focus: true, touch: true }}
          style={{ fontFamily: 'Inter' }}
          classNames={{ tooltip: styles.tooltip }}
        >
          <span className={styles.labelTooltipTarget}>{labelElement}</span>
        </CustomTooltip>
      ) : (
        labelElement
      )}
      {children || (
        <input
          id={id}
          className={`${styles.input} ${error ? styles.inputError : ''} ${className}`}
          aria-invalid={Boolean(error)}
          {...inputProps}
        />
      )}
      {error && <p className={styles.error}>{error}</p>}
    </div>
  );
}
